import axios from 'axios';

import { BASE_URL } from '../../inc/constants';
import {fetchCategoriesStarted,fetchCategoriesSuccess,fetchCategoriesError, setCurrentCategoryAction,setSubCategoriesStatusAction, setMenuCategoryAction} from './actions';
import { AppState } from '..';
import { logOut, handleCache } from '../base/functions';

export const fetchCategories = () => {
    return (dispatch: any,getState: any) =>  {
        dispatch(fetchCategoriesStarted());
        let state:AppState = getState();
        const headers = {Authorization: `token ${state.base.token}`};
        axios.get(`${BASE_URL}/categories/`,{headers})
        .then(res => {
          dispatch(fetchCategoriesSuccess(res.data));
        })
        .catch(err => {
          dispatch(fetchCategoriesError(err));
          handleCache(dispatch,err);
        });

    };
};

export const setCurrentCategory = (id: number) => {
  return (dispatch: any) =>  {
      dispatch(setCurrentCategoryAction(id));
  };
};
export const setMenuCategory = (categoryId: number) => {
  return (dispatch: any) =>  {
      dispatch(setMenuCategoryAction(categoryId));
  };
};
export const setSubCategoriesStatus = (open: boolean) => {
  return (dispatch: any) =>  {
      dispatch(setSubCategoriesStatusAction(open));
  };
};

export function clone(obj: any) {
  if (null == obj || "object" != typeof obj) return obj;
  var copy = obj.constructor();
  for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}

export const getCategory = (categories: any, id: number) => {
  if(!categories || !id || id==0)  return;
  let cat = clone(categories[id.toString()]);
  if(!cat) return;
  let tempChildren = cat.children;
  delete cat.children;
  cat.children = [];
  tempChildren.map((child: number)=>{
    cat.children.push(categories[child.toString()])
  })
  return cat; 
}